<template>
  <div class="sewageDeal_historicalTrend _boxBg_dark absolute_center">
    <div class="selfClose_btn" @click="close"></div>
    <div class="_boxTitle">污水处理厂运行历史趋势</div>
    <div class="_yellowLine"></div>
    <div class="_innerBox">
      <div class="_contentBox">
        <div class="dialog_form">
          <div class="public-form">
            <el-form :inline="true" class="demo-form-inline">
                <el-form-item label="污水处理厂排口：" prop="outletName">
                <el-select :class="'_boxBg_dark_select'" v-model="outletName" placeholder="请选择排口">
                  <el-option v-for="(item,i) in outletList" :key="i" :label="item.deviceName" :value="item.deviceNo"></el-option>
                </el-select>
              </el-form-item>
              <DatePicker
                :init-width="'420px'"
                :start-time-str="timeArr[0]"
                :end-time-str="timeArr[1]"
                @dateChange="changeTime"
                :current-date-list="timeArr"
                topPx="50px"
                dateType="timerange"
              >
              </DatePicker>
              <div class="self_btn" @click="checkFun">查询</div>
              <div class="self_btn" @click="reset">重置</div>
            </el-form>
          </div>
        </div>
        <div class="itemCon">
          <div class="content">
            <div class="item" v-for="(item , i) in otherChart" :key="i">
              <div class="chart" :ref="'chart'+i"></div>
            </div>
            <div class="nodata" v-if="otherChart.length ==0">暂无数据</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import getOpt from './chartOpt.js'
import { unwarp } from '@/utils/tools.js'
import { DatePicker } from "@/modules/commonDatePicker";
export default {
  name: 'wushuichuli_history',
  title: '污水处理厂运行历史趋势',
  props: ['globalInstance'],
  setup(props) {
    const globalInstance = props.globalInstance
    return { globalInstance }
  },
  components:{
    DatePicker
  },
  data() {
        return {
          customerId: this.globalInstance.$store.state.customerId,
          color: ['#2E82FF', '#01BFA5', '#FA6400', '#6DD400'],
          outletList: [],
          outletName: '',
          timeArr: [],
          type: 2,
          otherChart: [],
          chart_tuoliu: []
        }
      },
      mounted() {
        this.init()
      },
      computed: {
        // ...mapState({ dialog: (state) => state.dialog }),
        // ...mapGetters(['dialogVisible']),
      },
      beforeUnmount() {
        for (var i = 0; i < this.otherChart.length; i++) {
          if (this.chart_tuoliu[i]) {
            this.chart_tuoliu[i] = this.chart_tuoliu[i].dispose()
            this.chart_tuoliu[i] = null
          }
        }
      },
      methods: {
      changeTime(e) {
          this.timeArr = e;
     },
    async init() {
      let jiekou1 = {
        customerId: this.customerId,
        type: this.type
      }
      let findQgDevice = CONFIG.requestName + this.globalInstance.$apiOpt.findQgDevice
      let data = await this.globalInstance.$apiUtils.get(findQgDevice, jiekou1)
      if (data.length) {
        this.outletList = data
        this.outletName = data[0].deviceNo
        this.getChart()
      }
    },
    formatDateTime(inputTime) {
      inputTime = parseInt(inputTime)
      if (inputTime) {
        var date = new Date(inputTime)
        var y = date.getFullYear()
        var m = date.getMonth() + 1
        m = m < 10 ? '0' + m : m
        var d = date.getDate()
        d = d < 10 ? '0' + d : d
        var h = date.getHours()
        h = h < 10 ? '0' + h : h
        var minute = date.getMinutes()
        var second = date.getSeconds()
        minute = minute < 10 ? '0' + minute : minute
        second = second < 10 ? '0' + second : second
        return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second
      }
    },
    async getData() {
      let jiekou2 = {}
      if (this.timeArr.length) {
        jiekou2 = {
          customerId: this.customerId, // 15
          type: this.type,
          deviceNo: this.outletName, //'AG-ZL-JHC-040'
          startTime: this.timeArr[0],
          endTime: this.timeArr[1]
        }
      } else {
        jiekou2 = {
          customerId: this.customerId, //15
          type: this.type,
          deviceNo: this.outletName, //'AG-ZL-JHC-040'
          startTime: this.formatDateTime(new Date().getTime() - 24 * 60 * 60 * 1000),
          endTime: this.formatDateTime(new Date().getTime())
        }
      }
      let findQgListDevice = CONFIG.requestName + this.globalInstance.$apiOpt.findQgListDevice
      let data = await this.globalInstance.$apiUtils.get(findQgListDevice, jiekou2)
      this.otherChart = data
      let aaa = []
      data.forEach((x, i) => {
        let dataObj = { xData: [], yData: [], key: '', unit: '' }
        dataObj.key = x.name
        dataObj.unit = x.unit ? x.unit : '--'
        x.list.forEach(_ => {
          dataObj.xData.push(_.time)
          dataObj.yData.push(_.value)
        })
        aaa.push(dataObj)
      })

      return aaa
    },
    async reset() {
      this.timeArr = []
    },
    async getChart() {
      let dataObj = await this.getData()
      let that = this
      this.$nextTick(() => {
        let echartList = []
        for (let i = 0; i < dataObj.length; i++) {
          let a = that.$refs[`${'chart' + i}`][0]
          that.chart_tuoliu[i] = echarts.init(a)

          unwarp(this.chart_tuoliu[i]).setOption(getOpt(dataObj[i], this.color[i % 4]))
          echartList.push(this.chart_tuoliu[i])
        }
        echarts.connect(echartList)
      })
    },
    checkFun() {
      this.getChart()
    },
    close() {
      let that = this._.appContext.app;
      this.$popup.close(that)
    }
  }
}
</script>

<style lang="scss" scoped="scoped">
.sewageDeal_historicalTrend {
  width: 1600px;
  ._innerBox {
    ._contentBox {
      .dialog_form {
        display: flex;
        justify-content: space-between;
        align-items: center;
        /*margin: 0px 0 40px;*/
        width: fit-content;
        .public-form {
          .el-form-item {
            margin-top: 0;
            .el-form-item__content {
              button {
                height: initial;
              }
            }
          }
        }
      }
      .itemCon {
        height: 600px;
        position: relative;
        .content {
          overflow: auto;
          height: 100%;
        }
        div::-webkit-scrollbar {
          width: 6px;
          height: 200px;
          color: #2e82ff;
        }
        div::-webkit-scrollbar-thumb {
          width: 8px;
          background: linear-gradient(180deg, #449eff 0%, #1e5cbb 100%);
          border-radius: 6px;
        }
        .nodata {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -20px;
          margin-top: -50px;
        }
      }
    }
  }
}

.chart {
  margin-top: 20px;
  width: 100%;
  height: 260px;
}
</style>
<style type="text/css">
._boxBg_dark .el-form-item__label {
  color: #99f5ff !important;
  font-weight: 500;
}
._boxBg_dark .el-form-item__content {
  border-radius: 2px !important;
  border: 1px solid !important;
  border-image: linear-gradient(90deg, #2e31ff, #01b0bf) 1 1 !important;
}
</style>
